/**
 * Returns scroll direction: "down" (scrolling down), "up" (scrolling up),
 * Checks every 100ms. Usage: if(getScrollDirection() === "down") hide();
 */
export const getScrollDirection = (() => {
  let lastScrollY = 0;
  let last = Date.now();

  return () => {
    const now = Date.now();
    if (now - last >= 100) {
      const currentScrollY = window.scrollY;

      const direction =
        currentScrollY > lastScrollY && currentScrollY > 100
          ? "down"
          : currentScrollY < lastScrollY || currentScrollY <= 100
            ? "up"
            : null;

      lastScrollY = currentScrollY;
      last = now;
      return direction;
    }
    return null;
  };
})();
